<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:10px;" style="margin-bottom: 15px">
      <!-- 搜索表单 -->
      <el-form :model="table.where" class="ele-form-search ele-table-tool-default" @keyup.enter.native="getTotalData()" @submit.native.prevent>
        <el-row :gutter="10" style="margin-top: 8px">
          <el-col :md="7" :sm="12">
            <el-form-item label="日期选择:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
            /></el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="getTotalData" size="small" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-data-table ref="table" :config="table" :data="data" :choose.sync="choose" highlight-current-row height="calc(100vh - 200px)">
        <template>
          <!--          <el-table-column type="selection" width="45" align="center" />-->
          <el-table-column prop="towerName" label="宿舍楼" show-overflow-tooltip />
          <el-table-column prop="storeyName" label="楼层" show-overflow-tooltip />
          <el-table-column prop="roomName" label="宿舍" show-overflow-tooltip />
          <el-table-column prop="score" label="分数" show-overflow-tooltip />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="getDetail(row)" icon="el-icon-view" type="primary" :underline="false">明细</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <el-dialog title="查看明细" :visible.sync="showDetail" width="50%">
      <ele-data-table ref="detailTable" :config="detailTable" height="calc(90vh - 300px)" highlight-current-row>
        <template #default="{ index }">
          <!--          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />-->
          <el-table-column prop="itemName" label="指标名称" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="itemValue" label="指标得分" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="teacherName" label="考评教师" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="assessTime" label="考评时间" sortable="custom" show-overflow-tooltip />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-popconfirm title="确定要删除此数据吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-dialog>
  </div>
</template>

<script>
  import { getDormitoryAssessReport, delRoomReportDetail } from '@/config/api';
  export default {
    name: 'Index',
    data() {
      return {
        table: {
          where: {
            startTime: null,
            endTime: null,
          },
          page: false,
        },
        date: null,
        aa: null,
        data: [],
        choose: [],
        detailTable: {
          // 表格配置
          url: '/school/report/getRoomReportDetail',
          where: { roomId: '' },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        showDetail: false,
      };
    },
    created() {
      this.setSelectTime();
      this.getTotalData();
    },
    methods: {
      // 默认本月日期
      setSelectTime() {
        let _this = this;
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        let start_month = y + '-' + '01';
        let end_month = `${y}-${m}`;

        let start_day = y + '-' + m + '-' + '01';
        let end_day = `${y}-${m}-${d}`;

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.table.where.startTime = start_day; // 传入后台的 开始时间
        this.table.where.endTime = end_day; // 传入后台的 结束时间
      },
      // 获取宿舍考核汇总
      getTotalData() {
        this.table.where = {
          startTime: this.date[0],
          endTime: this.date[1],
        };
        getDormitoryAssessReport(this.table.where).then((res) => {
          if (res.data.resCode == 200) {
            this.data = res.data.data;
          }
        });
      },
      // 获取明细数据
      getDetail(row) {
        this.showDetail = true;
        this.detailTable.where.roomId = row.id;
        this.$refs.detailTable.doLayout();
        this.$refs.detailTable.reload({ page: { page: 1 } });
      },
      // 删除明细数据
      remove(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        delRoomReportDetail(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.detailTable.reload({ page: { page: 1 } });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
